import z from "zod";

// `message` is a translation KEY, not a translated string. The server
// returns the key and the client passes it through `t(...)`. Keeps the
// server locale-agnostic — mirrors footer.newsletter.
export const membersClubFormSchema = z.object({
	email: z
		.string()
		.min(1, { message: "membersClubForm.fieldError.emailRequired" })
		.email({ message: "membersClubForm.fieldError.emailInvalid" }),
	firstName: z.string().min(1, { message: "membersClubForm.fieldError.firstNameRequired" }),
	lastName: z.string().min(1, { message: "membersClubForm.fieldError.lastNameRequired" }),
	phone: z.string().optional(),
	necessaryEmail: z.literal(true, {
		message: "membersClubForm.fieldError.necessaryEmailRequired",
	}),
	promotionalEmail: z.boolean().optional(),
});

export type MembersClubFormInput = z.infer<typeof membersClubFormSchema>;
